import { observable, action, runInAction } from 'mobx';
import axios from 'axios';

export class BotConfigStore {
    @observable configurations = [];

    constructor({ rootStore }) {
        this.rootStore = rootStore;
    }

    @action async getConfigurations() {
        const response = await axios.get(`${this.rootStore.env.botApi}`, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });

        runInAction(() => {
            this.configurations = response.data;
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/BotConfigStore.js